module.exports = __webpack_public_path__ + "img/bg.99db9729.jpg";